// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/chunks/" + (chunkId === 873 ? "heatmap" : chunkId) + ".chunk.js?id=" + {"670":"cdfcb0965bc52fcd","873":"ebfa8e20a541517d"}[chunkId] + "";
};